import { api } from "@/api/client";
import type { components } from "@/api/contract";
import { unwrap } from "@/api/errors";

export type ConversationDetailResponse = components["schemas"]["ConversationDetailResponse"];
export type Conversation = components["schemas"]["Conversation"];

/** GET /v1/chat/conversations/{id} — the conversation + its active-path messages. */
export async function getConversationDetail(id: string): Promise<ConversationDetailResponse> {
  return unwrap(await api.GET("/v1/chat/conversations/{id}", { params: { path: { id } } }));
}

/** PATCH /v1/chat/conversations/{id}/active-branch — switch the active branch. */
export async function setActiveBranch(conversationId: string, leafMessageId: string): Promise<void> {
  unwrap(
    await api.PATCH("/v1/chat/conversations/{id}/active-branch", {
      params: { path: { id: conversationId } },
      body: { leaf_message_id: leafMessageId },
    }),
  );
}

/** POST /v1/chat/conversations/{id}/fork — branch a message into a new conversation. */
export async function forkConversation(
  conversationId: string,
  messageId: string,
): Promise<Conversation> {
  return unwrap(
    await api.POST("/v1/chat/conversations/{id}/fork", {
      params: { path: { id: conversationId } },
      body: { message_id: messageId },
    }),
  );
}
